import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    business_name: "AlikamaFish",
    tagline: "Premium Ocean-Fresh Seafood",
    phone: "07352554647",
    email: "hello@alikamafish.com",
    facebook: "#", instagram: "#", tiktok: "#", whatsapp: "#",
    chatbot_welcome: "Hi! I'm Kama, your AlikamaFish assistant. How can I help you?",
    chatbot_quick_replies: ["What's in stock?", "How do I order?", "Tell me about cooking classes"],
  });

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings((prev) => ({ ...prev, ...data }));
    } catch (_) {}
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsCtx.Provider value={{ settings, refresh }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
